import gql from 'graphql-tag';

export const GET_FILTER_OPTIONS = gql`
  query GET_FILTER_OPTIONS($filterId: String!, $searchTerm: String, $offset: Int, $limit: Int, $after: String) {
    getFilterOptions(filterId: $filterId, searchTerm: $searchTerm, offset: $offset, limit: $limit, after: $after) {
      options {
        value
        label
      }
      hasNextPage
      totalCount
      nextCursor
    }
  }
`;
